// extracted by mini-css-extract-plugin
export default {"header":"QYwYOqmKSYUINNBYlZgZ","titleGroup":"jFcklcohyqmHLlbwAOuW","backButton":"vLQhCwuxVB2in6Ntjq_0"};